import { withStyles } from '@material-ui/core/styles';

import ProductCard from './ProductCard';
import styles from './ProductCard.styles';

export default withStyles(styles)(ProductCard);
